var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnAlertSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2169_37507)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_2169_37507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0002 9.60787C27.8102 10.6529 29.3158 12.1525 30.3681 13.9582C31.4203 15.764 31.9827 17.8132 31.9996 19.9031C32.0165 21.993 31.4873 24.051 30.4643 25.8735C29.4413 27.696 27.9601 29.2197 26.1673 30.2939C24.3745 31.368 22.3322 31.9553 20.2427 31.9975C18.1531 32.0398 16.0888 31.5357 14.2539 30.535C12.4191 29.5343 10.8775 28.0717 9.78162 26.2921C8.68576 24.5125 8.07369 22.4775 8.006 20.3887L8 19.9999L8.006 19.6111C8.0732 17.5387 8.67627 15.519 9.75639 13.7491C10.8365 11.9791 12.3568 10.5192 14.1691 9.51173C15.9815 8.50425 18.0239 7.98355 20.0974 8.0004C22.1708 8.01725 24.2045 8.57107 26.0002 9.60787ZM24.4486 16.7515C24.242 16.5449 23.967 16.4207 23.6754 16.4024C23.3838 16.3841 23.0955 16.4728 22.8646 16.6519L22.7518 16.7515L18.8001 20.7019L17.2485 19.1515L17.1357 19.0519C16.9048 18.8729 16.6166 18.7843 16.325 18.8027C16.0334 18.8211 15.7586 18.9452 15.552 19.1518C15.3454 19.3584 15.2213 19.6332 15.2029 19.9248C15.1845 20.2163 15.2731 20.5046 15.4521 20.7355L15.5517 20.8483L17.9517 23.2483L18.0645 23.3479C18.275 23.5111 18.5338 23.5998 18.8001 23.5998C19.0665 23.5998 19.3253 23.5111 19.5357 23.3479L19.6485 23.2483L24.4486 18.4483L24.5482 18.3355C24.7273 18.1046 24.816 17.8163 24.7977 17.5247C24.7793 17.233 24.6552 16.9581 24.4486 16.7515Z",
    fill: "url(#paint0_linear_2169_37507)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8022 16.3979L24.8021 16.3979C24.5094 16.1052 24.1199 15.9294 23.7068 15.9034C23.2936 15.8774 22.8852 16.0031 22.5581 16.2568C22.5497 16.2633 22.5416 16.2701 22.5336 16.2771L22.4208 16.3767C22.4131 16.3835 22.4056 16.3906 22.3983 16.3979L18.8 19.995L17.6019 18.7978C17.5947 18.7905 17.5872 18.7835 17.5795 18.7767L17.4667 18.6771C17.4587 18.67 17.4504 18.6632 17.442 18.6567C17.1149 18.4031 16.7066 18.2776 16.2935 18.3037C15.8805 18.3297 15.4911 18.5056 15.1985 18.7982C14.9058 19.0909 14.73 19.4802 14.7039 19.8933C14.6778 20.3063 14.8034 20.7147 15.0569 21.0418C15.0634 21.0502 15.0702 21.0584 15.0773 21.0664L15.1769 21.1792C15.1837 21.187 15.1908 21.1945 15.1981 21.2018L17.5982 23.6018C17.6055 23.6091 17.613 23.6162 17.6208 23.6231L17.7336 23.7227C17.7415 23.7297 17.7497 23.7364 17.758 23.7429C18.0562 23.9742 18.4228 24.0998 18.8001 24.0998C19.1775 24.0998 19.5441 23.9742 19.8422 23.7429C19.8506 23.7364 19.8587 23.7297 19.8667 23.7227L19.9795 23.6231C19.9872 23.6162 19.9948 23.6091 20.0021 23.6018L24.8022 18.8018C24.8095 18.7945 24.8166 18.787 24.8234 18.7792L24.923 18.6664C24.93 18.6585 24.9368 18.6503 24.9433 18.6419C25.197 18.3148 25.3227 17.9064 25.2967 17.4933C25.2707 17.0801 25.0949 16.6907 24.8022 16.3979ZM25.7502 10.0409C27.4847 11.0424 28.9276 12.4795 29.9361 14.21C30.9445 15.9405 31.4834 17.9043 31.4996 19.9071C31.5158 21.9099 31.0086 23.8822 30.0283 25.6288C29.048 27.3753 27.6285 28.8356 25.9103 29.8649C24.1922 30.8943 22.235 31.4571 20.2326 31.4976C18.2301 31.5382 16.2517 31.055 14.4933 30.096C12.735 29.137 11.2576 27.7354 10.2074 26.0299C9.15791 24.3256 8.57143 22.377 8.50587 20.3767L8.50006 19.9999L8.50587 19.6231C8.57096 17.6385 9.1488 15.7045 10.1832 14.0095C11.2183 12.3133 12.6753 10.9142 14.4121 9.94874C16.1489 8.98324 18.1062 8.48423 20.0933 8.50038C22.0804 8.51653 24.0293 9.04727 25.7502 10.0409Z",
    stroke: "url(#paint1_linear_2169_37507)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2169_37507",
    x: 0,
    y: -2,
    width: 40,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2169_37507"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_innerShadow_2169_37507"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2169_37507",
    result: "effect2_innerShadow_2169_37507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_2169_37507",
    x: 4,
    y: 6,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2169_37507"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2169_37507",
    result: "effect2_dropShadow_2169_37507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2169_37507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2169_37507",
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2169_37507",
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnAlertSuccess);
export default __webpack_public_path__ + "static/media/icn-alert-success.b8c4d870c089396edd5a17b260049db4.svg";
export { ForwardRef as ReactComponent };